import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=5aa59b08&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&lang=ts"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=5aa59b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa59b08",
  null
  
)

export default component.exports